import React, { useEffect, useState } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { Cascader, Col, Form, Input, Row, Spin, Switch, message } from 'antd';
import CommonHead from '@/components/common-head';
import Crumb from '@/components/crumb';
import { menuData } from './config';
import Invoice from './invoice';
import UModal from '@/components/modal';

import './index.scss';
import { addAddress, deleteAddress, editAddress, getAddressDetail, getAreaList } from '@/api/personal-center';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@/redux/store';
import { useAppSelector } from '@/redux/hooks';
import { getAddressList, setDeleteModalState, setEditModalState } from '@/redux/address';

interface IItem {
  title: string;
  path: string;
  id: number | string;
}
type RouterMap = {
  [key: string]: string;
};


interface DynamicRoute { 
  regex: RegExp;
  title: any ;
  clickHandler?: (() => void) | null;
}
const PersonalCenter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const handleItem = (item: IItem) => {
    if (item.id === 'account') {
      window.open(item.path);
    } else {
      navigate(item?.path);
    }
  };
  useEffect(() => {
    getLev1CascaderData(); // 个人中心首页获取级联数据的第一级
  }, []);

  const [form] = Form.useForm();
  const { TextArea } = Input;
  // 省市区县级联数据
  const [cascaderOption, setCascaderOption] = useState([]);
  // 级联外层显示
  const [placeText, setPlaceText] = useState('');
  const { deleteModalState, editModalState } = useSelector((state: RootState) => state.addressReducer);
  const { applyCount } = useAppSelector(state => state.user);
  // 添加对 编辑/新增 弹窗的监听
  useEffect(() => {
    if (editModalState.open) {
      // 先清空数据
      form.resetFields();
      form.setFieldValue('cityText', '');
      setPlaceText('');
      // 有id就调用详情接口
      if (editModalState.id) {
        getAddressDetail(editModalState.id).then((res: any) => {
          const picks = [res.obj.province, res.obj.city, res.obj.region];
          form.setFieldsValue({
            ...res.obj,
            id: res.obj.id,
            picks,
          });
          setPlaceText(picks.join('/'));
        });
      }
    }
  }, [editModalState]);

  /** 获取省一级的数据 */
  const getLev1CascaderData = () => {
    const params = {
      parentCode: 0,
    };
    getAreaList(params).then((res: any) => {
      if (res.success) {
        setCascaderOption(
          res.obj.map((v: any) => {
            return { ...v, isLeaf: false };
          })
        );
      }
    });
  };

  const deleteModalOk = () => {
    dispatch(
      setDeleteModalState({
        ...deleteModalState,
      })
    );
    deleteAddress(deleteModalState.id).then((res: any) => {
      if (res.success) {
        dispatch(
          setDeleteModalState({
            ...deleteModalState,
            open: false,
          })
        );
        dispatch(getAddressList());
        message.success('操作成功');
        return;
      }
      message.error(res.message);
    });
  };
  const deleteModalCancel = () => {
    dispatch(
      setDeleteModalState({
        ...deleteModalState,
        open: false,
      })
    );
  };

  const editModalOk = () => {
    const api = editModalState.isAdd ? addAddress : editAddress;
    form
      .validateFields()
      .then((values) => {
        const [province, city, region] = values.picks;
        if (!values.defaultStatus) {
          values.defaultStatus = 0;
        }
        api({ ...values, province, city, region }).then((res: any) => {
          if (res.success) {
            dispatch(getAddressList());
            message.success('操作成功');
            dispatch(
              setEditModalState({
                title: '',
                isAdd: true,
                open: false,
                id: '',
              })
            );
            return;
          }
          message.error(res.message);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const editModalCancel = () => {
    dispatch(
      setEditModalState({
        title: '',
        isAdd: true,
        open: false,
        id: '',
      })
    );
  };

  const fieldNames = {
    label: 'name',
    value: 'name',
    children: 'areas',
  };
  // 加在对应的地址
  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    const params = {
      parentCode: targetOption.areaCode,
    };
    getAreaList(params)
      .then((res: any) => {
        targetOption.loading = false;
        targetOption.areas = res.obj.map((v: any) => {
          return {
            ...v,
            isLeaf: v.level === 3,
            areas: [],
          };
        });
        setCascaderOption([...cascaderOption]);
      })
      .finally(() => {
        targetOption.loading = false;
      });
  };

  const onCascaderChange = (value: any, selectedOptions: any) => {
    const text = selectedOptions.map((v: any) => v.name);
    form.setFieldValue('cityText', text.join('/'));
    setPlaceText(text.join('/'));
  };

  // 订单页面跳出父组件布局，直接写true false 会有点抖动，这里过渡一下
  const [isNeedJump, setIsNeedJump] = useState('loading');
  useEffect(() => {
    const pass = () => {
      return location.pathname.startsWith('/user/confirm');
    };
    setIsNeedJump(pass() ? 'jump' : 'noJump');
  }, [location.pathname]);

  const handleGo = () => {
    navigate('/user/orderList');
  }

  const handleGo1 = () => {
    navigate('/user/as/List');
  }
  // 定义路由映射
const routerMap: RouterMap = {
  '/user': '个人中心',
  '/user/orderList': '我的订单',
  '/user/invoice': '开票信息',
  '/user/address': '收货地址',
  '/user/receipt': '我的发票',
  '/user/coupon': '优惠券',
  '/user/as/List': '售后服务',
};

// 定义动态路由配置
const dynamicRoutes:DynamicRoute[] = [
  {
    regex: /^\/user\/orderList\/(-\d|\d+)$/,
    title: '我的订单',
    clickHandler: null,
  },
  {
    regex: /^\/user\/order\/detail\/(\d+)$/,
    title: (
      <span>
        <span onClick={handleGo} style={{ cursor: 'pointer' }}>我的订单</span> {'>'} 订单详情
      </span>
    ),
    clickHandler: null,
  },
  {
    regex: /^\/user\/as\/(-\d|\d+)$/,
    title: (
      <span>
        <span onClick={handleGo} style={{ cursor: 'pointer' }}>我的订单</span> {'>'} 申请售后
      </span>
    ),
    clickHandler: null,
  },
  {
    regex: /^\/user\/as\/detail\/(\d+)$/,
    title: (
      <span>
        <span onClick={handleGo1} style={{ cursor: 'pointer' }}>售后服务</span> {'>'} 售后详情
      </span>
    ),
    clickHandler: null,
  },
];

// 定义动态路由匹配函数
const getTitleByPath = (pathname: string): JSX.Element => {
  // 先尝试匹配静态路由
  if (routerMap[pathname]) {
    return <span>{routerMap[pathname]}</span>;
  }

  // 尝试匹配动态路由
  for (const { regex, title } of dynamicRoutes) {
    if (regex.test(pathname)) {
      return typeof title === 'function' ? title() : title;
    }
  }

  return <span>未知页面</span>;
};
 
  // 修改 getMenuItemClassName 函数
const getMenuItemClassName = (path: string | undefined, itemId: any, locationPathname: string, isOrderDetail: boolean, isOrderList: boolean, isOrderAs: boolean, shouldHighlightAsList: boolean, shouldHighlightOrderList: boolean) => {
  const baseClass = 'menu-item-content-item';
  // 新增 isOrderDetail 且 isOrderList 为 true 时的高亮条件
  const firstHighlightCondition = path && (
    locationPathname.includes(itemId) || 
    shouldHighlightAsList || 
    shouldHighlightOrderList || 
    (isOrderDetail && isOrderList)
  );
  const firstClass = firstHighlightCondition ? `${baseClass} highlight` : baseClass;
  const secondClass = isOrderDetail && isOrderList && isOrderAs ? ' highlight' : '';
  return `${firstClass}${secondClass}`;
};
  return (
    <>
      <div className="personal-center-wrap">
        {isNeedJump === 'loading' && <Spin></Spin>}
        {isNeedJump === 'noJump' && (
          <>
            <CommonHead type="classify" />
            <div className="personal-center">
              <div className="personal-center-content">
                <Crumb title={'首页'} subTitle={getTitleByPath(location.pathname)} />
                <div className="personal-center-content-main">
                  <div className="content-left">
                    {menuData.map((item: any) => {
                      return (
                        <div className="menu-item" key={item.id}>
                          <div
                            className={`${item.path && location.pathname === item?.id ? 'menu-item-title highlight' : 'menu-item-title'}`}
                            onClick={() => handleItem(item)}
                          >
                            {item.title}
                          </div>
                          <div className="menu-item-content">
                            {item?.children &&
                              item?.children.map((items: any) => {
                                // 检查是否在订单详情页面

                                const isOrderDetail = location.pathname.startsWith('/user/order/detail/');
                                const isOrderList = items.path === '/user/orderList';
                                const isOrderAs = /^\/user\/as\/(-\d|\d+)$/.test(location.pathname);
                                // 新增判断是否在售后相关页面，使用更简洁的正则
                                const isAsRelated = /^\/user\/as(\/detail\/)/.test(location.pathname);
                                const shouldHighlightAsList = items.path === '/user/as/List' && isAsRelated;
                                // 新增是否要高亮我的订单的判断
                                const shouldHighlightOrderList = isOrderAs && isOrderList ;
                                const className = getMenuItemClassName(items.path, items.id, location.pathname, isOrderDetail, isOrderList, isOrderAs,shouldHighlightAsList,shouldHighlightOrderList);
                                return (
                                  <div
                                    className={className}
                                    key={items.id}
                                    onClick={() => handleItem(items)}
                                  >
                                    {items.title}
                                    {
                                      (items.id === 'as/List' && applyCount > 0) &&
                                      <i>{applyCount > 9 ? '9+' : applyCount}</i>
                                    }
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="content-right">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {isNeedJump === 'jump' && <Outlet />}
      </div>
      {/* 两个页面存在地址管理 */}
      <UModal
        title="删除提醒"
        width={450}
        open={deleteModalState.open}
        cancelText="否"
        okText="是"
        onOk={deleteModalOk}
        onCancel={deleteModalCancel}
        centered
        className="address-edit-modal"
      >
        <div style={{ padding: '50px 0', textAlign: 'center' }}>请确认是否删除该地址？</div>
      </UModal>

      <UModal
        centered
        width={900}
        title={editModalState.title}
        open={editModalState.open}
        initialValues={editModalState}
        cancelText="取消"
        okText="保存"
        onCancel={editModalCancel}
        onOk={editModalOk}
        className="address-edit-modal"
      >
        <Form form={form} layout="vertical" autoComplete="off">
          <Form.Item name="id" hidden>
            <Input maxLength={11} />
          </Form.Item>
          <Row gutter={15}>
            <Col span={12}>
              <Form.Item
                label="收货人"
                name="name"
                // 修改 getValueFromEvent 函数，调用 trim 方法去除前后空格
                getValueFromEvent={(e) => {
                  const value = typeof e === 'object' && e.target ? e.target.value : e;
                  return value?.trim();
                }}
                rules={[
                  { required: true, message: '请输入收货人' },

                ]}>
                <Input maxLength={50} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="手机号码"
                name="tel"
                rules={[
                  { required: true, message: '请输入手机号码' },
                  {
                    pattern: /^1[3-9]\d{9}$/,
                    message: '请输入正确格式的手机号码',
                  },
                ]}
              >
                <Input maxLength={11} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="收货地址" name="picks" rules={[{ required: true, message: '请选择收货地址' }]}>
            <Cascader fieldNames={fieldNames} options={cascaderOption} loadData={loadData} onChange={onCascaderChange} placeholder="选择省/市/区县">
              <div>{placeText ? <div className="show-text">{placeText}</div> : <div className="placeholder-text">选择省/市/区县</div>}</div>
            </Cascader>
          </Form.Item>
          <Form.Item
            label="详细地址"
            name="detailAddress"
            // 修改 getValueFromEvent 函数，调用 trim 方法去除前后空格
            getValueFromEvent={(e) => {
              const value = typeof e === 'object' && e.target ? e.target.value : e;
              return value?.trim();
            }}
            rules={[
              { required: true, message: '请输入详细地址' }
            ]}
          >
            <TextArea
              placeholder="详细地址，路名或街道名称，门牌号"
              maxLength={200}
              style={{
                height: 64,
                resize: 'none'
              }}
            />
          </Form.Item>
          {/* <Form.Item label="设为默认地址" name="defaultStatus" valuePropName="checked" getValueFromEvent={(checked) => (checked ? 1 : 0)}>
            <Switch />
          </Form.Item> */}
          <Form.Item
            label="设为默认地址"
            name="defaultStatus"
            valuePropName="checked"
            getValueFromEvent={(checked) => (checked ? 1 : 0)}
            // 设置 labelCol 和 wrapperCol 来控制布局
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
            className='switch-item'
          >
            <Switch className='switch-item-content' />
          </Form.Item>
        </Form>
      </UModal>
    </>
  );
};

export default PersonalCenter;
